import { render, staticRenderFns } from "./TestSection.DynamicView.vue?vue&type=template&id=4f8ece72&scoped=true"
import script from "./TestSection.DynamicView.vue?vue&type=script&lang=ts"
export * from "./TestSection.DynamicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ece72",
  null
  
)

export default component.exports